export const DEFAULT_ANIMATION_DURATION = 0.3;
export const TYPE_WRITER_DELAY_PERCENT = 70;
export const FADE_START_OPACITY = 0.15;
export const SLIDE_IN_OFFSET = 100;
export const POP_IN_PEAK_PROGRESS = 0.5;
export const POP_IN_SCALES = {
  START: 0.8,
  PEAK: 1.2,
  FINAL: 1.0,
} as const;
